/**
 * Precomputed eligibility for the recommendation engine (docs/04 §3.2).
 * rankCards() receives this object and must not call deriveGrace or getCardState internally.
 */

import type { Cents } from './money';
import { getCardState, type CardState, type GetCardStateArgs } from './state';
import { deriveGrace, type DeriveGraceInput, type GraceResult } from './grace';

export type CapacityContext = {
  estimated_available_credit: Cents | null;
  available_credit_observed_at: string | null;
  state_age_days: number | null;
};

export type CardEligibilityContext = {
  state: CardState;
  grace: GraceResult;
  capacity: CapacityContext;
};

export type BuildEligibilityArgs = {
  stateArgs: GetCardStateArgs;
  graceArgs: DeriveGraceInput;
};

/** Orchestrator helper — Task 5's rankCards must consume the result, not re-derive. */
export function buildCardEligibilityContext(args: BuildEligibilityArgs): CardEligibilityContext {
  const state = getCardState(args.stateArgs);
  const grace = deriveGrace(args.graceArgs);
  return {
    state,
    grace,
    capacity: {
      estimated_available_credit: state.estimated_available_credit,
      available_credit_observed_at: state.observed.available_credit_cents_observed_at,
      state_age_days: state.state_age_days,
    },
  };
}
